import React from 'react'

export const Home = () => {
  return (
    <div>
        <h1 style={{textAlign: 'center', padding: 50}}>Bem vindo</h1>
    </div>
  )
}
